module.exports = __webpack_public_path__ + "img/p7_03.24f07df2.jpg";